import { render, staticRenderFns } from "./ChartPieView.vue?vue&type=template&id=6e3f7936"
import script from "./ChartPieView.vue?vue&type=script&lang=js"
export * from "./ChartPieView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports